<template>
  <el-container>
    <el-aside>
      <el-menu
        :default-active="activeIndex"
        class="listPublicTab"
        mode="vertical"
        @select="handleSelect"
      >
        <el-menu-item
          v-for="item in tabBarList"
          :key="item.id"
          :index="item.id"
          >{{ item.text }}</el-menu-item
        >
      </el-menu>
    </el-aside>
    <el-main
      style="position: relative; padding-bottom: 50px"
      v-show="!isRequest"
    >
      <ul>
        <li
          style="font-size: 14px; border-bottom: 1px dashed #ccc; padding: 2px"
          v-for="(item, index) in list"
          :key="index"
          @click="getDatas(item)"
          :title="item.title"
        >
          {{ item.title.slice(0, 50) }}
        </li>
      </ul>

      <el-pagination
        style="position: absolute; bottom: 0"
        :page-size="pageSize"
        :pager-count="11"
        :current-page="currentPage"
        layout="prev, pager, next"
        :total="size"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextNlick"
      ></el-pagination>
    </el-main>
    <el-main v-show="isRequest">
      <div class="container" v-if="activeIndex == '0401'" v-html="html"></div>
      <div
        class="container"
        v-else-if="activeIndex == '0402'"
        v-html="html"
      ></div>
    </el-main>
  </el-container>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      ipconfig: "http://116.115.106.58:17701/getfile/publiclist",
      activeIndex: "0401",
      isRequest: false,
      html: "",
      jsonData: null,
      list: null,
      tabBarList: [
        {
          text: "政务服务容缺受理制度",
          id: "0401",
        },
        {
          text: "窗口工作服务制度",
          id: "0402",
        },
      ],
      pageSize: 15,
      size: 0,
      currentPage: 1,
    };
  },
  created() {
    this.onLoadData(this.activeIndex);
  },
  methods: {
    onLoadData(val) {
      let _this = this;
      let data = {
        filenum: val,
      };
      _this.jsonData = null;
      _this.html = "";
      Axios.get("static/json/" + val + ".json").then(function (res) {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].filed = val;
        }
        _this.jsonData = res.data;
        _this.list = _this.jsonData.slice(
          _this.pageSize * _this.currentPage - _this.pageSize,
          _this.pageSize * _this.currentPage
        );
        _this.size = _this.jsonData.length;
      });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.onLoadData(key);
      this.html = "";
      this.isRequest = false;
      this.currentPage = 1;
    },
    getDatas(options) {
      let _this = this;
      var data = {
        filed: options.filed,
        filename: options.title + ".docx",
      };
      Axios.post(_this.ipconfig, data).then(function (res) {
        var content = `<div><h2 style='font-weight:bold;text-align:center;font-size:20px;'>${options.title}</h2><h4 style='text-align:center;margin-top:10px;'>时间：${options.time}</h4><hr></div>`;
        _this.html = content + res.data.html;
        _this.isRequest = true;
      });
    },
    currentChange(val, val2) {
      var a = this.pageSize * val;
      var b = a - this.pageSize;
      this.list = this.jsonData.slice(b, a);
      this.currentPage = val;
    },
    prevClick(val, val2) {},
    nextNlick(val, val2) {},
  },
};
</script>

<style scoped>
.el-aside {
  min-width: 100px;
  max-width: 240px;
}
.listPublicTab {
  width: 100%;
  border-right: 1px solid #ccc;
  margin-top: 10px;
}

.container >>> table tr td {
  border: 1px solid #333;
  padding: 5px;
}
.container >>> table tr td:first-child {
  min-width: 120px;
  max-width: 200px;
  vertical-align: 50%;
}
</style>


// WEBPACK FOOTER //
// src/pages/queryOnline/childPage/serveSystem.vue



// WEBPACK FOOTER //
// src/pages/queryOnline/childPage/serveSystem.vue